<template>
    <div class="container">
        <div class="activate_icon-success">
            <img src="../assets/images/ic-check.svg" v-if="!ac" />
            <img src="../assets/images/ic-check-ac.svg" v-if="ac" />
        </div>
        <h2
            class="activate_title"
            :class="{ 'ac-color-yellow': ac }"
            v-html="title"
        ></h2>

        <section class="info_container">
			<div v-for="(info, index) in infos" v-bind:key="index">
				<img :src="getImageSrc(index)" />
				<p class="activate_info"  v-html="info" />
			</div>
		</section>

		<span id="protocol" class="activate_protocol">
            {{ labelProtocol }} {{ protocol }}
        </span>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	data() {
		return {
			title: '',
			infos: '',
			infosImages: '',
			labelProtocol: '',
		};
	},
	computed: {
		...mapState({
			config: (state) => state.config,
			ac: (state) => state.ac,
			protocol: (state) => state.protocol,
        })
    },
	async created() {
		const config = this.config.pageSucess;
		this.title = config.clientExOi.title;
		this.infos = config.clientExOi.infos;
		this.infosImages = config.clientExOi.infosImages;
		this.labelProtocol = config.clientExOi.protocolo;
			
		if (this.protocol === '') return this.$router.push('/chip');
	},
	methods: {
		getImageSrc(index) {
			if (this.infosImages) {
				return require(`../assets/images/${this.infosImages[index]}`);
			} else {
				return '';
			}
		}
	}
}
</script>

<style lang="scss">
.info_container {
	margin-top: 15%;
	div {
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin: 10px 0;
		.activate_info {
			width: 252px;
			height: auto;
			display: block;
			position: relative;
			font-family: 'timsans_regular';
			font-size: 0.85em;
			line-height: 1.33;
			letter-spacing: -0.3px;
			color: #ffffff;
		}
	} 
}
</style>